import React from 'react';
import { STATUS_COLOR, STATUS_BORDER_COLOR } from '../constant';

function Legend() {
  return (
    <div className="d-flex align-items-center justify-content-center gap-2">
      <DotName
        name="Annual Leave Planned"
        dotColor={STATUS_COLOR?.planned}
        dotBorderColor={STATUS_BORDER_COLOR?.planned}
        nameColor={STATUS_BORDER_COLOR?.planned}
      />
      <DotName
        name="Annual Leave Taken"
        dotColor={STATUS_COLOR?.annual}
        dotBorderColor={STATUS_BORDER_COLOR?.annual}
        nameColor={STATUS_BORDER_COLOR?.annual}
      />
      <DotName
        name="Holiday"
        dotColor={STATUS_COLOR?.holiday}
        dotBorderColor={STATUS_BORDER_COLOR?.holiday}
        nameColor={STATUS_BORDER_COLOR?.holiday}
      />
      <DotName
        name="Weekend"
        dotColor={STATUS_COLOR?.weekend}
        dotBorderColor={STATUS_BORDER_COLOR?.weekend}
        nameColor={STATUS_BORDER_COLOR?.weekend}
      />
    </div>
  );
}

export default Legend;

function DotName({
  dotColor = '#000000',
  dotBorderColor = '#000000',
  name = '#000000',
  nameColor = '#000000',
  hasDot = true,
}) {
  return (
    <div className="px-2">
      <span>
        {hasDot && (
          <span
            style={{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: dotColor,
              border: `2px solid ${dotBorderColor}`,
              marginRight: '5px',
            }}
          />
        )}
        <span style={{ fontSize: '14px', color: nameColor }}>
          <strong>{name}</strong>
        </span>
      </span>
    </div>
  );
}
